// this file contains selectors that are used to get the current state of the application.
// these don't belong in base, but are often used in other selector files and need to be in
// a more base module to avoid circular dependencies.

import {
  courseSelectors,
  createAppSelector,
  sectionSelectors,
  selectCurrentSectionId,
  termSelectors,
} from "./base";

import { isSectionArchived } from "utils/archiving";

export const selectCurrentSection = createAppSelector(
  [selectCurrentSectionId, sectionSelectors.selectEntities],
  (sectionId, sections) => (sectionId && sectionId in sections ? sections[sectionId] : null),
);

// Lives here (rather than in section.ts) so lower-level selectors like edit-mode can reuse it
// without circular imports.
export const selectCurrentSectionIsArchived = createAppSelector(
  [selectCurrentSection, termSelectors.selectEntities, sectionSelectors.selectAll],
  (currentSection, terms, sections) => isSectionArchived(currentSection, terms, sections),
);

export const selectCurrentCourse = createAppSelector(
  [selectCurrentSection, courseSelectors.selectEntities],
  (section, courses) =>
    section?.course_id && courses[section.course_id] ? courses[section.course_id] : null,
);

export const selectCourseForSectionId = createAppSelector(
  [sectionSelectors.selectById, courseSelectors.selectEntities],
  (section, courses) =>
    section?.course_id && section.course_id in courses ? courses[section.course_id] : null,
);
